import React from 'react';

import {DataHookFolders, Folder} from '../../types';

import {
  SafeAreaView,
  StyleSheet,
  useWindowDimensions,
} from 'react-native';

import {ActivityIndicator} from 'react-native-paper';
import ContentItem from './items/contentitem';
import DragList, {
  DragListRenderItemInfo,
} from 'react-native-draglist';

export interface FolderLibraryProps {
  dataHook: DataHookFolders;
}

import {styles as stylesM} from './styles';
const FolderLibrary = (folderLibraryProps: FolderLibraryProps) => {
  const {dataHook} = folderLibraryProps;
  const dim = useWindowDimensions();
  const {height} = dim;
  const drawerOffset = dim.width > 700 ? 80 : 0;
  const width = dim.width - drawerOffset;
  let marginTop = 0;
  const {folders, loadingFolders, onReordered} = dataHook;
  const styles = StyleSheet.create({
    scroll: {
      height: height - 55,
      display: 'flex',
      position: 'relative',
      backgroundColor: 'black',
      marginTop,
      width: '100%',
    },
  });
  const mstyles = stylesM;
  mstyles.item.width = '100%';
  mstyles.scroll.height = height - 65;
  mstyles.scroll.marginTop = marginTop;
  const renderContent = ({
    item: i,
    onDragEnd,
    onDragStart,
  }: DragListRenderItemInfo<Folder>) => (
    <ContentItem
      i={i}
      key={i.id}
      dataHook={dataHook}
      styles={mstyles}
      width={width}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
    />
  );
  if (loadingFolders) {
    return <ActivityIndicator size={72} />;
  }
  return (
    <SafeAreaView style={{...styles.scroll}}>
      <DragList
        renderItem={renderContent}
        keyExtractor={item => item?.id || item?.date.toString()}
        style={{
          width: '100%',
          height,
          paddingBottom: 50,
        }}
        data={folders || []}
        showsVerticalScrollIndicator={false}
        showsHorizontalScrollIndicator={false}
        scrollEnabled={true}
        onReordered={onReordered}
      />
    </SafeAreaView>
  );
};

export default FolderLibrary;
